import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router';
import PathwayActionsDropdown from '@/components/pathways/PathwayActionsDropdown';
import { isPathwaySucceeded } from '@/utils/pathwayUtils';
import { formatDateShort } from '@/utils/miscUtils';
import { LockClosedIcon } from '@heroicons/react/24/outline';
import featureConfig from '@/featureConfig';

const PathwayRow = ({ pathway, projectId, isAdmin, isSelected = false, onSelectionChange }) => {
  const navigate = useNavigate();

  const viewAnalysis = e => {
    e.preventDefault();
    navigate(`/projects/${projectId}/analysis/pathways/${pathway.id}`);
  };

  const continueBuild = e => {
    e.preventDefault();
    navigate(`/projects/${projectId}/build/pathways/${pathway.id}/${pathway.case_id}`);
  };

  return (
    <tr className={`group ${isSelected ? 'bg-gray-50' : 'bg-white hover:bg-gray-50'}`}>
      <td className="py-2 pl-4 pr-0">
        {onSelectionChange && (
          <input
            type="checkbox"
            className="checkbox checkbox-sm"
            checked={isSelected}
            onChange={event => onSelectionChange(pathway.id, event.target.checked)}
            onClick={event => event.stopPropagation()}
            aria-label={`Select pathway ${pathway.name}`}
          />
        )}
      </td>
      <td>
        <Link
          className="flex items-center py-2 px-4 text-sm text-gray-700 hover:text-gray-900"
          to={`/projects/${projectId}/build/pathways/${pathway.id}/${pathway.case_id}`}
        >
          {pathway.name}
        </Link>
      </td>
      <td className="text-left py-2 px-4">
        <div className="flex items-center justify-start min-h-[24px] w-32">
          <span className="group-hover:hidden">
            {isPathwaySucceeded(pathway) ? (
              <div className="inline-flex rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                Analysis Complete
              </div>
            ) : (
              <div className="inline-flex items-center rounded-full bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                In Progress
              </div>
            )}
          </span>
          <span className="group-hover:flex hidden">
            {isPathwaySucceeded(pathway) ? (
              <button onClick={viewAnalysis} className="btn btn-xs btn-secondary">
                View Analysis
              </button>
            ) : (
              <button onClick={continueBuild} className="btn btn-xs btn-secondary">
                Continue Build
              </button>
            )}
          </span>
        </div>
      </td>
      <td className="text-left text-sm text-gray-500 py-2 px-4">{formatDateShort(pathway.created_at)}</td>
      <td className="text-left text-sm text-gray-500 py-2 px-4">{formatDateShort(pathway.updated_at)}</td>
      <td className="text-right py-2 px-4">
        {featureConfig.managePathways && (
          <div className="flex items-center justify-end min-h-[24px] w-16">
            <span className="group-hover:hidden">{pathway.locked && <LockClosedIcon className="h-4 w-4" />}</span>
            <span className="group-hover:flex hidden">
              <PathwayActionsDropdown pathway={pathway} isAdmin={isAdmin} />
            </span>
          </div>
        )}
      </td>
    </tr>
  );
};

PathwayRow.propTypes = {
  pathway: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    analysis_status: PropTypes.object,
    analysis_stale: PropTypes.bool,
    locked: PropTypes.bool,
    case_id: PropTypes.string,
    updated_at: PropTypes.string,
    created_at: PropTypes.string,
  }),
  projectId: PropTypes.string,
  isAdmin: PropTypes.bool,
  isSelected: PropTypes.bool,
  onSelectionChange: PropTypes.func,
};

export default PathwayRow;
